// Valores editables de la landing. Todo lo que figura entre [corchetes]
// es un dato a completar con información real.

export const offerConfig = {
  launchPrice: 19990,
  // Precio que se muestra cuando vence la reserva de 10 minutos.
  // EDITAR con el precio siguiente real.
  nextPrice: 29990,
  reservationMinutes: 10,
  guaranteeDays: 7,
  checkoutUrl: 'https://vitalidad-360-adultos-mayores.impultienda.ar/checkout',
}

export const urgencyConfig = {
  totalCupos: 15,
  // Cupos con precio de lanzamiento que quedan hoy. Editar a mano o conectar un endpoint.
  cuposDisponiblesHoy: 9,
  // Endpoint opcional que devuelve un número o { value: number } con los cupos reales.
  cuposEndpoint: null as string | null,
  // Endpoint opcional que devuelve un número o { value: number } con visitantes activos.
  activeViewersEndpoint: null as string | null,
  // Familias que lo descargaron esta semana (dato real). Si queda en null, la línea no se muestra.
  descargasEstaSemana: null as number | null,
}

export const contactConfig = {
  supportEmail: '[correo]',
  whatsappNumber: '[número]',
}

export const authorConfig = {
  name: 'Claudia Beatriz Sosa',
  role: 'Cuidadora de adultos mayores · +18 años de experiencia',
  // URL de la foto real (idealmente WebP, cuadrada). Si queda vacía, se muestran las iniciales.
  photoUrl: '',
  signature: 'Claudia',
  bio: [
    'Hace más de 18 años que acompaño a adultos mayores. Mi vocación nació cuidando a mi propia abuela, y con el tiempo aprendí que cuidar no es solo cumplir una rutina: es escuchar, tener paciencia, estar atenta a los detalles y transmitir tranquilidad, a la persona y a su familia.',
    'Creé este sistema porque sé lo difícil que es encontrar orientación y herramientas confiables cuando tenés que cuidar a alguien que amás. Reuní en un solo lugar todo lo que, en estos años, vi que realmente ayuda.',
    'Mi propósito es que ninguna familia sienta que tiene que atravesar esto sola.',
  ],
}

export const valueMathConfig = {
  sesionDomicilio: '[$XX.XXX]',
  cuadernilloLibreria: '[$X.XXX]',
}
